
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { rechargeLog } from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
msg: "",
show: false,
list: [],
finished: false,
loading: false,
type: 1,
history: 1
}
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN()
this.getData()
},
methods:{
...mapMutations(['SETTOKEN']),
onLoad() {
this.getData()
},
timeChange(time) {
var date = new Date(time*1000);
var Y = date.getFullYear() + '-';
var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
var D = date.getDate() <10 ? '0'+date.getDate() + ' ' : date.getDate()+' ';
var h = date.getHours() + ':';
var m = date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes() ;
var s = date.getSeconds();
return Y+M+D+h+m;
},
getData(){
var that = this
this.$Loading()
if(this.history==1){
rechargeLog({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.list = res.data || []
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
}else{
withdrawLog({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.list = res.data || []
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
}

},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
watch: {
type: {
handler(curVal, oldVal) {
this.getData()
},
deep: true
}
}
}



// WEBPACK FOOTER //
// ./src/pages/moneyLog.vue